import { setUnauthorizedHandler } from '@/shared/api/api-client';
import { expireSession, probeSession } from '@/pages/authentication/state/session';
import { setSyncSessionProbe } from '@/shared/api/sync';

let initialized = false;

// initializeAppLifecycle wires transport failures to the application-level session cleanup flow.
export function initializeAppLifecycle() {
  if (initialized) {
    return;
  }

  initialized = true;
  setUnauthorizedHandler(expireSession);
  setSyncSessionProbe(async () => probeSession());
}
